import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {

}

model.validForm = {
    'dich_vu.ve_dien_tu.ten': [ValidService.required],
    'dich_vu.ve_dien_tu.url': [ValidService.required, ValidService.checkLink],
    'loai_hinh': [ValidService.required],
    'dich_vu.ve_dien_tu.anh_hien_thi': [ValidService.required],
    'dich_vu.visible': [ValidService.required],
    'dich_vu.ngon_ngu': [ValidService.required],
}
model.dataFormOther = {
    id: undefined, // optional
    duyet: // optional
    {
        duoc_duyet: undefined, // required Cho biết dịch vụ đã được duyệt hay chưa
        thoi_diem_duoc_duyet: undefined, // optional Cho biết thời điểm dịch vụ đã được duyệt
        nguoi_duyet_id: undefined, // optional Mã người duyệt
    },
    loai_hinh: undefined, // optional 0: vé máy bay, 1: vé điện tử
    ten: undefined, // optional Tên
    url: undefined, // optional Đường dẫn đến mua vé
    mediaId: undefined, // optional Id ảnh hiển thị
    thoi_gian_tao: undefined, // optional
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
    },
}

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            "ve_dien_tu.ten": "",
            // ready: true,
            ngon_ngu: "",
            "don_vi_cung_cap.loai": ""
        },
        valid: {
            "ve_dien_tu.ten": []
        },
        operator: {
            "ve_dien_tu.ten": ":regex_i:" //:regex:, $vn_text=Viêt nam
        }
    }
};

export default model;